<template>

<app-wrapper>

	<app-text>

		<app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_general_title">

                <app-input-check :label="page.business_profile_about_general_visible_label" v-model="inputs.general_visible" :errored="errored.general_visible" />
                <app-input-text :label="page.business_profile_about_general_name_label" v-model="inputs.general_name" :errored="errored.general_name" :placeholder="page.business_profile_about_general_name_placeholder" />
                <app-input-image :label="page.business_profile_about_general_avatar_label" v-model="inputs.general_avatar" :errored="errored.general_avatar" :placeholder="page.business_profile_about_general_avatar_placeholder" v-on:change="inputs.general_avatarRaw = arguments[0]" />
                <app-input-text :label="page.business_profile_about_general_description_label" v-model="inputs.general_description" :errored="errored.general_description" :placeholder="page.business_profile_about_general_description_placeholder" :multiline="true" />
                <app-input-text :label="page.business_profile_about_general_status_label" maxlength="280" v-model="inputs.general_status" :errored="errored.general_status" :placeholder="page.business_profile_about_general_status_placeholder" />
                <app-input-text :label="page.business_profile_about_general_email_label" v-model="inputs.general_email" :errored="errored.general_email" :placeholder="page.business_profile_about_general_email_placeholder" />
                <app-input-text :label="page.business_profile_about_general_phone_label" v-model="inputs.general_phone" :errored="errored.general_phone" :placeholder="page.business_profile_about_general_phone_placeholder" />
                <app-input-text :label="page.business_profile_about_general_website_label" v-model="inputs.general_website" :errored="errored.general_website" :placeholder="page.business_profile_about_general_website_placeholder" />

            </app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_banner_title">

                <app-input-toggle :label="page.business_profile_about_banner_type_label" v-model="inputs.banner_type" :errored="errored.banner_type" :options="{1: page.business_profile_about_banner_type_choose, 2: page.business_profile_about_banner_type_upload}" />
                <app-input-gallery v-if="inputs.banner_type === $constants.banner.gallery" :label="page.business_profile_about_banner_choose_label" v-model="inputs.banner_gallery" :errored="errored.banner_gallery" :options="data.banners" :placeholder="page.business_profile_about_banner_choose_placeholder" />
                <app-input-image v-if="inputs.banner_type === $constants.banner.upload" :label="page.business_profile_about_banner_upload_label" v-model="inputs.banner_upload" :errored="errored.banner_upload" :placeholder="page.business_profile_about_banner_upload_placeholder" v-on:change="inputs.banner_uploadRaw = arguments[0]" />

            </app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_address_title">

                <app-input-text :label="page.business_profile_about_address_1_label" v-model="inputs.address_1" :errored="errored.address_1" :placeholder="page.business_profile_about_address_1_placeholder" />
                <app-input-text :label="page.business_profile_about_address_2_label" v-model="inputs.address_2" :errored="errored.address_2" :placeholder="page.business_profile_about_address_2_placeholder" />
                <app-input-text :label="page.business_profile_about_address_city_label" v-model="inputs.address_city" :errored="errored.address_city" :placeholder="page.business_profile_about_address_city_placeholder" />
                <app-input-select :label="page.business_profile_about_address_county_label" :options="data.counties" v-model="inputs.address_county" :errored="errored.address_county" :placeholder="page.business_profile_about_address_county_placeholder" />
                <app-input-text :label="page.business_profile_about_address_postcode_label" v-model="inputs.address_postcode" :errored="errored.address_postcode" :placeholder="page.business_profile_about_address_postcode_placeholder" />
                <app-input-check :label="page.business_profile_about_address_visible_label" v-model="inputs.address_visible" :errored="errored.address_visible" />
                
            </app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_opening_title">
                
                <app-group :row="!window.is.mobile" class="opening">

                    <div class="opening-item" v-for="opening in openings" :key="opening">
                        
                        <app-input-text :label="page['business_profile_about_opening_' + opening + '_label']" v-model="inputs['opening_' + opening]" :errored="errored['opening_' + opening]" :placeholder="page['business_profile_about_opening_' + opening + '_placeholder']" />

                    </div>

                </app-group>

            </app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_services_title">
                
                <app-input-checklist v-model="inputs.services" :errored="errored.services" :options="data.services" />

            </app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_facilities_title">
                
                <app-input-checklist v-model="inputs.facilities" :errored="errored.facilities" :options="data.facilities" />

            </app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_social_title">
                
                 <app-input-text v-for="social in socials" :key="social"  :label="page['business_profile_about_social_' + social + '_label']" v-model="inputs['social_' + social]" :errored="errored['social_' + social]" :placeholder="page['business_profile_about_social_' + social + '_placeholder']" />

            </app-group>

            <app-group :collapsed="true" :title="page.business_profile_about_hygiene_title">
                
                <app-input-check :label="page.business_profile_about_hygiene_applicable_label" v-model="inputs.hygiene_applicable" :errored="errored.hygiene_applicable" />

                <app-input-scale :label="page.business_profile_about_hygiene_rating_label" :max="5" v-if="inputs.hygiene_applicable" v-model="inputs.hygiene_pending" :errored="errored.hygiene_pending" />

                <p class="notice" v-if="inputs.hygiene_applicable && session.business.hygiene.pending && session.business.hygiene.pending !== session.business.hygiene.rating">{{ page.business_profile_about_hygiene_pending }}</p>
                <p class="notice" v-if="inputs.hygiene_applicable && session.business.hygiene.pending && session.business.hygiene.pending === session.business.hygiene.rating">{{ page.business_profile_about_hygiene_verified }}</p>

            </app-group>

		</app-group>

		<app-group :row="true" :center="true">

			<app-button :success="is.saved" :fail="is.errored" :text="page.business_profile_about_button_save" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />

		</app-group>

	</app-text>

</app-wrapper>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinForm],

	data: function() {

		return {
            stayAfterSave: true,
            openings: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
            socials: ['twitter', 'facebook', 'instagram', 'linkedin', 'tiktok', 'pinterest'],
			inputs: {
				general_visible: 1,
                general_name: '',
                general_avatar: '',
				general_avatarRaw: '',
                general_description: '',
                general_status: '',
				general_phone: '',
				general_email: '',
                general_website: '',
                banner_type: 1,
                banner_gallery: 0,
                banner_upload: '',
                banner_uploadRaw: '',
                address_1: '',
                address_2: '',
                address_city: '',
                address_county: 0,
                address_postcode: '',
                address_visible: 0,
                opening_monday: '',
                opening_tuesday: '',
                opening_wednesday: '',
                opening_thursday: '',
                opening_friday: '',
                opening_saturday: '',
                opening_sunday: '',
                social_twitter: '',
                social_facebook: '',
                social_instagram: '',
				social_linkedin: '',
				social_tiktok: '',
				social_pinterest: '',
                services: [],
                facilities: [],
                hygiene_applicable: 0,
                hygiene_pending: 0
			},
			rules: {
				general_name: {
                    required: true
                },
				general_phone: {
                    required: true
                },
				address_1: {
                    required: true
                },
				address_city: {
                    required: true
                },
				address_county: {
                    required: true
                },
				address_postcode: {
                    required: true
                }
			}
		}

	},

	methods: {

		resetValues: function() {

            this.inputs.general_name = this.session.business.name
            this.inputs.general_visible = this.session.business.visible
            this.inputs.general_avatar = this.session.business.image.avatar
			this.inputs.general_avatarRaw = ''
            this.inputs.general_description = this.session.business.text.description
            this.inputs.general_status = this.session.business.text.status
            this.inputs.general_website = this.session.business.contact.website
            this.inputs.general_phone = this.session.business.contact.phone
            this.inputs.general_email = this.session.business.contact.email

            this.inputs.banner_type = this.session.business.banner.type
            this.inputs.banner_gallery = this.session.business.banner.gallery
            this.inputs.banner_upload = this.session.business.image.banner
            this.inputs.banner_uploadRaw = ''
            
            this.inputs.address_1 = this.session.business.address.first
            this.inputs.address_2 = this.session.business.address.second
            this.inputs.address_city = this.session.business.address.city
            this.inputs.address_county = this.session.business.address.county
            this.inputs.address_postcode = this.session.business.address.postcode
            this.inputs.address_visible = this.session.business.address.visible

            this.inputs.opening_monday = this.session.business.opening.monday
            this.inputs.opening_tuesday = this.session.business.opening.tuesday
            this.inputs.opening_wednesday = this.session.business.opening.wednesday
            this.inputs.opening_thursday = this.session.business.opening.thursday
            this.inputs.opening_friday = this.session.business.opening.friday
            this.inputs.opening_saturday = this.session.business.opening.saturday
            this.inputs.opening_sunday = this.session.business.opening.sunday

            this.inputs.social_twitter = this.session.business.social.twitter
            this.inputs.social_facebook = this.session.business.social.facebook
            this.inputs.social_instagram = this.session.business.social.instagram
            this.inputs.social_linkedin = this.session.business.social.linkedin
            this.inputs.social_tiktok = this.session.business.social.tiktok
            this.inputs.social_pinterest = this.session.business.social.pinterest

            this.inputs.services = this.session.business.services
            this.inputs.facilities = this.session.business.facilities

            this.inputs.hygiene_applicable = this.session.business.hygiene.applicable
            this.inputs.hygiene_pending = this.session.business.hygiene.pending

		},

		onSaveClick: function() {

			this.save('account/profile/about', this.inputs)

		}

	}
}

</script>

<style scoped>

.opening {
    width: 100%;
}

.opening-item {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    margin-right: 5px;
}

.is-mobile .opening-item {
	margin-right: 0px;
	margin-bottom: 5px;
}

.opening-item >>> .input-content {
    flex-direction: column;
}

.opening-item >>> .input-content-label {
    width: 100%;
    line-height: 20px;
}

</style>
